module.exports = {
      id: "default-author-usage",
      viewBox: "0 0 122 120",
      url: __webpack_public_path__ + "svg-sprite-6b422ea7dc08f55780ae3689062e9e73.svg#default-author",
      toString: function () {
        return this.url;
      }
    }